import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TransferPaymentResponse {
  /**
   * Variable symbol, main payment demand identification.
   */
  @observable
  variableSymbol!: number;

  @observable
  @Type(() => DomesticBankAccountResponse)
  bankAccount!: DomesticBankAccountResponse;

  /**
   * SFDI bank account IBAN.
   */
  @observable
  iban!: string;

  /**
   * Message for recipient, one of other payment demand identifiers.
   */
  @observable
  message!: string;

  /**
   * Due date for transfer payment.
   */
  @observable
  @Type(() => Date)
  dueDate!: Date;
}
